import { useState } from 'react';
import { buildStandardReport } from '../lib/standardReport.mjs';
import { downloadAssessmentReport } from '../lib/assessmentReport';

export default function StandardReportScreen({assessment,answers,contact,delivery}) {
  const report=buildStandardReport(assessment,answers);
  const [downloading,setDownloading]=useState(false);
  const [error,setError]=useState('');
  const download=async()=>{
    setDownloading(true);setError('');
    try { await downloadAssessmentReport(assessment,answers,contact); }
    catch { setError('Unable to prepare the PDF report. Please try again.'); }
    finally { setDownloading(false); }
  };
  return <section className="report-screen expanded premium-report" aria-label="Your assessment report">
    <header className="report-hero">
      <div className="report-hero-top"><span className="question-kicker">YOUR PERSONALISED ASSESSMENT</span>
        <button type="button" className="report-download-button" onClick={download} disabled={downloading}>
          {downloading?'Preparing PDF…':'Download PDF report'}
        </button>
      </div>
      <h1>{assessment.title}</h1>
      <p className="report-business">Prepared for <strong>{contact.businessName}</strong> | {contact.firstName}</p>
    </header>
    <div className="report-overview">
      <div className="report-score-block"><div className="report-score-label">OVERALL HEALTH SCORE</div>
        <div className="report-score-value">{report.score}<span>/100</span></div>
        <div className="report-score-meter"><span style={{width:report.score+'%'}}/></div>
      </div>
      <div className="report-score-details"><span className="report-status">{report.band}</span>
        <h2>Your operational snapshot</h2><p>Indicative findings based on the answers you provided.</p>
      </div>
    </div>
    <div className="report-panel"><div className="report-section-head"><h2>Operational findings</h2></div>
      <div className="report-areas-grid">{report.dimensions.map(area=>
        <div className="report-area-card" key={area.key}><div className="report-area-title"><strong>{area.label}</strong>
          <span>{area.score}<small>/{area.maxPoints}</small></span></div>
          <div className="report-area-track"><span style={{width:100*area.score/area.maxPoints+'%'}}/></div>
          <p>{area.finding}</p></div>)}</div>
    </div>
    <div className="report-panel"><div className="report-section-head"><h2>Priority improvements</h2></div>
      <div className="report-risks">{report.risks.map((area,i)=>
        <div className="report-risk-card" key={area.key}><span className="report-risk-number">{String(i+1).padStart(2,'0')}</span>
          <div><h3>{area.label}</h3><p>{area.recommendation}</p></div></div>)}</div>
    </div>
    <div className="report-next-step"><span className="question-kicker">RECOMMENDED NEXT STEP</span>
      <h2>Your next step</h2><p>{report.nextStep}</p></div>
    <div className="report-bottom-action"><div><strong>Keep a copy of your results</strong>
      <p>Download your personalised A4 report.</p></div><button className="report-download-button" disabled={downloading}
      onClick={download}>{downloading?'Preparing PDF…':'Download my PDF'}</button></div>
    {error&&<p role="alert" className="form-error">{error}</p>}
    {delivery&&<p className="delivery-message" role="status">{delivery}</p>}
    <p className="report-disclaimer">Indicative results only, based on your answers. Not professional advice.</p>
  </section>;
}